import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const addIndividualBeneficiaryFeatureKey = 'addIndividualBeneficiary';

export interface AddIndividualBeneficiaryState {
  addIndividualBeneficiaryResponse: string | null;
  addIndividualBeneficiaryFailure: Error | any;
}

export const initialState: AddIndividualBeneficiaryState = {
  addIndividualBeneficiaryResponse: null,
  addIndividualBeneficiaryFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.addIndividualBeneficiarySuccess, (state, action) => ({
    ...state,
    addIndividualBeneficiaryResponse: action.response
  })),
  on(actions.addIndividualBeneficiaryFailure, (state, action) => ({
    ...state,
    addIndividualBeneficiaryFailure: action.error
  }))
);
